import { Badge } from "../common/styles";
import { jsx as _jsx } from "react/jsx-runtime";
const STYLE = {
  rounded: "full",
  className: "absolute top-3 right-3"
};
export const RoundTimeBadge = _ref => {
  let {
    roundStates
  } = _ref;
  if (roundStates !== null && roundStates !== void 0 && roundStates.includes("accepting-applications")) {
    return /*#__PURE__*/_jsx(Badge, {
      color: "green",
      ...STYLE,
      children: "Apply!"
    });
  } else if (roundStates !== null && roundStates !== void 0 && roundStates.includes("ended")) {
    return /*#__PURE__*/_jsx(Badge, {
      color: "orange",
      ...STYLE,
      children: "Round ended"
    });
  } else {
    return null;
  }
};